import { Box, Flex } from "rebass";
import React, { forwardRef } from "react";
import { BsSliders } from "react-icons/bs";
import Chip from "./Chip";
import Bin from "../../icons/Bin";
import Close from "../../icons/Close";
import Search from "../../icons/Search";
import SearchInput from "./SearchInput";
import { getLocalizedText } from "../../utils/getLocalizedText";

const FiltersAndSearchMobile = forwardRef(
  (
    {
      activeFilters,
      removeFilter,
      onRemoveAllFilters,
      isFiltered,
      onSearchKeyUp,
      onSearchSubmit,
      openFilter,
      setOpenFilter,
      openSearch,
      setOpenSearch,
      sx,
      children,
    },
    inputSearchRef,
  ) => {
    const lang = localStorage.getItem("B2BLanguage") === "ITA" ? "it" : "en";

    const enableSearch =
      typeof onSearchKeyUp === "function" &&
      typeof onSearchSubmit === "function";

    function removeAllFilters() {
      if (inputSearchRef?.current) inputSearchRef.current.value = "";
      onRemoveAllFilters();
    }

    const handleSubmit = (e) => {
      onSearchSubmit?.(e);
      setOpenSearch(false);
    };
    return (
      <Box
        sx={{
          maxHeight: "60vh",
          overflowY: "auto",
          mt: "10px",
          ...sx,
        }}
      >
        <Flex
          alignItems="flext-start"
          sx={{
            gap: "2px",
            minHeight: "40px",
          }}
        >
          {!!openSearch ? (
            <Flex
              flex="1 0 70%"
              sx={{
                border: "1px solid #f2f2f2",
              }}
            >
              <SearchInput
                ref={inputSearchRef}
                onKeyUp={onSearchKeyUp}
                onSubmit={handleSubmit}
                sx={{ width: "100%" }}
                style={{ height: "38px" }}
              />
            </Flex>
          ) : (
            <Flex
              alignItems="flext-start"
              flex="1 0 70%"
              padding="8px"
              bg="#f2f2f2"
              sx={{
                gap: "5px",
              }}
            >
              <Box
                onClick={() => {
                  setOpenFilter((filter) => !filter);
                  setOpenSearch(false);
                }}
                paddingTop={"4px"}
              >
                <BsSliders />
              </Box>
              <Flex
                flex={1}
                sx={{ gap: "5px", flexWrap: "wrap" }}
                onClick={() => {
                  if (!activeFilters?.length && !openFilter) {
                    setOpenFilter(false);
                    setOpenSearch((search) => !search);
                  }
                }}
              >
                {!!activeFilters?.length &&
                  activeFilters?.map((filter, index) => {
                    const { value, text } = filter || {};
                    if (!value || !text) return null;
                    return (
                      <Chip
                        key={`mobile-filter-chips-${index}`}
                        text={getLocalizedText(text)}
                        remove={() => removeFilter(value)}
                      />
                    );
                  })}
              </Flex>
              {!!isFiltered && (
                <Box sx={{ paddingTop: "7px" }} onClick={removeAllFilters}>
                  <Bin style={{ width: "16px", height: "14px" }} />
                </Box>
              )}
            </Flex>
          )}
          <Flex padding="11px 8px 8px" bg="#f2f2f2">
            {openFilter || openSearch ? (
              <Box
                onClick={() => {
                  setOpenSearch(false);
                  setOpenFilter(false);
                }}
              >
                <Close style={{ width: "20px", height: "20px" }} />
              </Box>
            ) : (
              <Box
                paddingTop={"1px"}
                onClick={() => {
                  setOpenFilter(false);
                  setOpenSearch((search) => !search);
                }}
                sx={{
                  visibility: enableSearch ? "visible" : "hidden",
                  pointerEvents: enableSearch ? "default" : "none",
                }}
              >
                <Search style={{ width: "20px", height: "20px" }} />
              </Box>
            )}
          </Flex>
        </Flex>
        {openFilter && children}
      </Box>
    );
  },
);

export default FiltersAndSearchMobile;
